export const FETCH_SECTION_FORM_REQUEST = "FETCH_SECTION_FORM_REQUEST";
export const FETCH_SECTION_FORM_SUCCESS = "FETCH_SECTION_FORM_SUCCESS";
export const FETCH_SECTION_FORM_FAIL = "FETCH_SECTION_FORM_FAIL";

export const CREATE_SECTION_FORM_REQUEST = "CREATE_SECTION_FORM_REQUEST";
export const CREATE_SECTION_FORM_SUCCESS = "CREATE_SECTION_FORM_SUCCESS";
export const CREATE_SECTION_FORM_FAIL = "CREATE_SECTION_FORM_FAIL";

export const FETCH_FIELD_REQUEST = "FETCH_FIELD_REQUEST";
export const FETCH_FIELD_SUCCESS = "FETCH_FIELD_SUCCESS";
export const FETCH_FIELD_FAIL = "FETCH_FIELD_FAIL";

export const SHOW_FIELD_REQUEST = "SHOW_FIELD_REQUEST";
export const SHOW_FIELD_SUCCESS = "SHOW_FIELD_SUCCESS";
export const SHOW_FIELD_FAIL = "SHOW_FIELD_FAIL";

export const DELETE_FIELD_REQUEST = "DELETE_FIELD_REQUEST";
export const DELETE_FIELD_SUCCESS = "DELETE_FIELD_SUCCESS";
export const DELETE_FIELD_FAIL = "DELETE_FIELD_FAIL";

export const CREATE_FIELD_REQUEST = "CREATE_FIELD_REQUEST";
export const CREATE_FIELD_SUCCESS = "CREATE_FIELD_SUCCESS";
export const CREATE_FIELD_FAIL = "CREATE_FIELD_FAIL";

export const CREATE_DROP_DOWN_VALUE_REQUEST = "CREATE_DROP_DOWN_VALUE_REQUEST";
export const CREATE_DROP_DOWN_VALUE_SUCCESS = "CREATE_DROP_DOWN_VALUE_SUCCESS";
export const CREATE_DROP_DOWN_VALUE_FAIL = "CREATE_DROP_DOWN_VALUE_FAIL";

export const SHOW_DROP_DOWN_VALUE_REQUEST = "SHOW_DROP_DOWN_VALUE_REQUEST";
export const SHOW_DROP_DOWN_VALUE_SUCCESS = "SHOW_DROP_DOWN_VALUE_SUCCESS";
export const SHOW_DROP_DOWN_VALUE_FAIL = "SHOW_DROP_DOWN_VALUE_FAIL";

export const DELETE_DROP_DOWN_VALUE_REQUEST = "DELETE_DROP_DOWN_VALUE_REQUEST";
export const DELETE_DROP_DOWN_VALUE_SUCCESS = "DELETE_DROP_DOWN_VALUE_SUCCESS";
export const DELETE_DROP_DOWN_VALUE_FAIL = "DELETE_DROP_DOWN_VALUE_FAIL";

